/**
 * Cordova plugin provides access to some native dialog UI elements via a global navigator.notification object.
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/cordova-plugin-dialogs
 */
import { AlertCallback, AlertOptions, ConfirmCallback, ConfirmOptions } from "./types";

class Notification {
  private get plugin (): any {
    return (window as any)?.navigator.notification;
  }

  alert (
    { message, title = "Alert", buttonName = "OK" }: AlertOptions,
    callback?: AlertCallback
  ): void {
    this.plugin.confirm (
      message,
      callback,
      title,
      buttonName
    );
  }

  confirm (
    { message, title = "Confirm", buttonLabels }: ConfirmOptions,
    callback: ConfirmCallback
  ): void {
    this.plugin.confirm (
      message,
      callback,
      title,
      buttonLabels
    );
  }
}

export default new Notification();